import Swiper from 'swiper/bundle'
window.Swiper = Swiper

import '@monolith/app_root/mobile_roadblock.js'
